/**
 * Edit Controller
 */
/*
  globals moment
*/
(function(angular) {
  'use strict';

  var app = angular.module('asSecureCommerce');

  app.controller('IpsPathsController', [
    '$scope',
    '$window',
    '$timeout',
    'seApi',
    function($scope, $window, $timeout, seApi) {
        $scope.msgSaved = $window.msgSaved;
        
        $scope.data = {
            ac_wl_ips: data.ac_wl_ips ? data.ac_wl_ips.join("\n") : '',
            ac_bl_ips: data.ac_bl_ips ? data.ac_bl_ips.join("\n") : '',
            ac_bl_paths: data.ac_bl_paths ? data.ac_bl_paths.join("\n") : '',
            site_ids: ''
        };                
        
      // try saving and process server side validation errors
      $scope.submitForm = function(isModalWindowOpened) {          
          $scope.msgSaved = '';
          $scope.data.site_ids = $window.getSelectedSites();
          
          if (!$window.getSelectedSites().length) {
              return;
          }
          
          seApi.save("ipsPathsControl", $scope.data).then(
          function() {
            $window.location.href = '/#!/se/ipsPathsControl';
            $scope.msgSaved = 'Ips and Paths have been saved';            
          },
          function(data) {
//             defaultSaveErrorHandler($scope.ipsPathsForm, data);
             $scope.msgSaved = data.message;
          }
        );
      };



      //$timeout( function(){$scope.fetch();}, 20);
      // $scope.fetch();
    }
  ]);
})(window.angular);
